import { createContext, useContext } from 'react'

type CellOverlayCtx = {
  // Called by each Tooltip/Popover rendered inside the cell pill so the
  // overlay can stay visible while any of them is open — without this,
  // moving the cursor onto a portaled tooltip/popover (which lives outside
  // the cell element) fires mouseleave and hides the trigger button itself.
  notifyOpenChange: (open: boolean) => void
}

const NOOP: CellOverlayCtx = { notifyOpenChange: () => {} }

export const CellOverlayContext = createContext<CellOverlayCtx>(NOOP)
export const useCellOverlayContext = () => useContext(CellOverlayContext)
